import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';

import { sanitizeGenericHtml } from 'utils/sanitize';

import './deliverable-sub-header.scss';

type Props = {
  directon: 'row' | 'column',
  title: string,
  emptyNote?: string,
  instruction?: string | false,
  isCaptionHeader?: boolean,
  tooltipMsg?: string | false
}

const DeliverableSubHeader = ({ title, emptyNote, instruction, directon, tooltipMsg, isCaptionHeader }: Props) => {
  const containerClass = classnames('deliverable-sub-header', `deliverable-sub-header--${directon}`, {
    'deliverable-sub-header--caption': isCaptionHeader
  });

  const instructionClasses = classnames('deliverable-sub-header__instruction', {
    'deliverable-sub-header__instruction--caption': isCaptionHeader
  });

  return (
    <div className={containerClass}>
      <div className="deliverable-sub-header__section-title">
        {title}
        {
          tooltipMsg && (
            <Tooltip
              showQuestionMark
              message={tooltipMsg}
              classNameWrapper="deliverable-sub-header__tooltip"
            />
          )
        }
      </div>
      {
        instruction && (
          <div
            className={instructionClasses}
            dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(instruction) }}
          />
        )
      }
      {
        emptyNote && (
          <div className="deliverable-sub-header__empty-note">
            {emptyNote}
          </div>
        )
      }
    </div>
  );
};

export default DeliverableSubHeader;
